import { ConfigRepo } from "@common/domain/repositories/ConfigReporsitory";
import { call, ForkEffect, takeLatest } from "redux-saga/effects";
import {
  addRegistrationDataFailure,
  addRegistrationDataSuccess,
  configAction,
} from "./action";

import {
  IAddRegistrationPayload,
  IGetCollaborativeFormUserAction,
  IGetCollaborativeSharePermissionAction,
  IGetRegistrationPayload,
  IUploadCollaborativeShareUserAction,
} from "./interface";

function* addRegisterUserData(action: IAddRegistrationPayload) {
  try {
    yield call(ConfigRepo.addRegistrationData, action.payload);
    addRegistrationDataSuccess();
  } catch (error) {
    addRegistrationDataFailure(error.message);
  }
}
function* getRegistrationData(action: IGetRegistrationPayload) {
  const { onError, onSuccess } = action.payload;
  try {
    const response = yield call(
      ConfigRepo.getSubscriptionBundle,
      action.payload
    );
    yield onSuccess(response);
  } catch (error) {
    onError(error.message);
  }
}

function* UploadCollaborativeShareUserListSaga(action: IUploadCollaborativeShareUserAction) {
  const { onSuccessUserShareListUpload, onFailureUserShareListUpload } = action.payload;
  try {
    const formCollaborativeShareUploadResponse = yield call(
      ConfigRepo.updatedCollaborativeShareUserList,
      action.payload
    );
    onSuccessUserShareListUpload(formCollaborativeShareUploadResponse);
  } catch (error) {
    onFailureUserShareListUpload(error);
  }
}

function* GetCollaborativePermissionListSaga(action: IGetCollaborativeSharePermissionAction) {
  const { onSuccessUserPermissionListUpload, onFailureUserPermissionListUpload, collaborativeUserId } = action.payload;
  try {
    const formCollaborativeSharePermissiomnResponse = yield call(
      ConfigRepo.getCollaborativePermissionList,
      action.payload
    );

   yield onSuccessUserPermissionListUpload(formCollaborativeSharePermissiomnResponse);
  } catch (error) {
    onFailureUserPermissionListUpload(error);
  }
}

function* GetCollaborativeFormUserListSaga(action: IGetCollaborativeFormUserAction) {
  const { onSuccessFormUserListUpload, onFailureFormUserListUpload, collaborativeFormId } = action.payload;  
  try {
    const formCollaborativeFormUserResponse = yield call(
      ConfigRepo.getCollaborativeFormUserList,
      action.payload
    );

   yield onSuccessFormUserListUpload(formCollaborativeFormUserResponse);
  } catch (error) {
    onFailureFormUserListUpload(error);
  }
}

export function* watchConfig(): Generator<ForkEffect> {
  yield takeLatest(configAction.ADD_REGISTRATION_DATA, addRegisterUserData);
  yield takeLatest(configAction.UPLOAD_COLLABORATIVE_SHARE, UploadCollaborativeShareUserListSaga);
  yield takeLatest(configAction.GET_COLLABORATIVE_PERMISSION_LIST, GetCollaborativePermissionListSaga);
  yield takeLatest(configAction.GET_COLLABORATIVE_FORM_USER_LIST, GetCollaborativeFormUserListSaga);
  yield takeLatest(configAction.GET_REGISTRATION_DATA, getRegistrationData);
}
